import { Button, View, Text } from "react-native";
import MCALayout from "./MCALayout";
import { colorPrimary } from "../theme/colors";
import React from 'react'

const SuccessScreen = (props:any) => {
    console.log("Message");
    console.log(props);
    console.log(props,message);
    var message = props.message || "Lorem Ipsum"

    function onDone() {
        props.onDonePressed()
    }
  return (
    <MCALayout>
            <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>

                <Text style={{ fontFamily: "Raleway_500Medium", fontSize: 18, textAlign: "center" }}>
                    {message}
                </Text>
            </View>
            <Button title="Done" color={colorPrimary} onPress={onDone} />
        </MCALayout>
  )
}

export default SuccessScreen